import { IconNames } from '@blueprintjs/icons';
import { Button } from '@strata/react-buttons';
import { DialogWithForm } from '@strata/react-dialog';
import { SuccessToast } from '@strata/react-toast-message';
import { Formik } from 'formik';
import PropTypes from 'prop-types';

import { useDeleteBatchMutation } from 'store/api/goLiveApi';

const Title = 'Delete batch';

export const DeleteBatchDialog = ({ isOpen, onClose, batch = undefined }) => {
    const [deleteBatch] = useDeleteBatchMutation();
    const treatmentCount = batch?.treatment_count ?? 0;

    return (
        <Formik
            initialValues={{}}
            enableReinitialize
            onSubmit={async () => {
                await deleteBatch({ batchId: batch.batch_id }).unwrap();
                SuccessToast({ message: `Batch "${batch.batch_name}" deleted.` });
                onClose();
            }}
        >
            {(formik) => (
                <DialogWithForm
                    dialogTitle={Title}
                    headerIcon={IconNames.WARNING_SIGN}
                    isOpen={isOpen}
                    width={440}
                    secondaryButtonLabel="Cancel"
                    onSecondaryButtonClick={onClose}
                    primaryButtonLabel="Yes, delete batch"
                    primaryButtonIntent={Button.Intent.DANGER}
                    isPrimaryButtonDisabled={formik.isSubmitting}
                    dialogContent={
                        <p>
                            Deleting <strong>{batch?.batch_name}</strong> will disassociate{' '}
                            {treatmentCount.toLocaleString()} upcoming{' '}
                            {treatmentCount === 1 ? 'treatment' : 'treatments'} and set them back to
                            NEW LOAD status.
                        </p>
                    }
                />
            )}
        </Formik>
    );
};

DeleteBatchDialog.Title = Title;

DeleteBatchDialog.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    batch: PropTypes.shape({
        batch_id: PropTypes.string.isRequired,
        batch_name: PropTypes.string.isRequired,
        treatment_count: PropTypes.number,
    }),
};
